import React from 'react'

/**
 * Skeleton shimmer: a highlight sweeping over the block it wraps. Keyframes are injected
 * once instead of living in a stylesheet, so loading markup stays Tailwind-only.
 */
if (typeof document !== 'undefined' && !document.getElementById('shimmer-styles')) {
  const style = document.createElement('style')
  style.id = 'shimmer-styles'
  style.textContent = `
    @keyframes shimmer {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `
  document.head.appendChild(style)
}

const ShimmerEffect = ({ className = '', children }) => (
  <div className={`relative overflow-hidden ${className}`}>
    {children}
    <div
      className="absolute inset-0 bg-gradient-to-r from-transparent via-Neutral-3/30 to-transparent"
      style={{
        animation: 'shimmer 2s infinite',
        transform: 'translateX(-100%)',
      }}
    />
  </div>
)

export default ShimmerEffect
